<template>
    <div class="s-form-schedule">
        <div class="s-form-schedule__title">
            {{ content.title }}
        </div>
        <div class="s-form-schedule__lead">
            {{ content.lead }}
        </div>

        <a-picture
            v-if="content.image"
            class="s-form-schedule__image"
            :link="content.image"
            :alt="content.imageAlt || content.title"
        />

        <div class="s-form-schedule__subtitle">
            {{ content.subtitle }}
        </div>
        <div class="s-form-schedule__body">
            {{ content.body }}
        </div>

        <a-button
            v-if="content.button"
            class="s-form-schedule__button"
            v-bind="content.button"
            :to="content.link"
        />
    </div>
</template>

<script>

import AButton from '@core/components/button/button.vue';
import APicture from '@core/components/picture/picture.vue';

export default {
    name: 'FormSchedule',
    components: {
        AButton,
        APicture,
    },
    props: {
        content: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="pcss" scoped>
.s-form-schedule {
    padding: 40px;
    background-color: var(--av-inversed-primary);
    box-shadow: var(--av-shadow-small);

    &__title {
        @mixin hero-accent;
        color: var(--av-nav-primary);
        margin-bottom: 16px;
        text-align: center;
    }

    &__lead {
        @mixin paragraph;
        text-align: center;
        color: var(--av-fixed-secondary);
        max-width: 440px;
        margin: 0 auto;
    }

    &__image {
        margin: 0 auto;
        height: 316px;
        width: auto;
    }

    &__subtitle {
        @mixin title;
        font-weight: 500;
        text-align: center;
        color: var(--av-nav-primary);
        margin-bottom: 8px;
    }

    &__body {
        @mixin body;
        text-align: center;
        color: var(--av-fixed-secondary);
        max-width: 290px;
        margin: 0 auto 24px;
    }

    &__button {
        width: 100%;
    }
}

@media (--viewport-mobile-wide) {
    .s-form-schedule {
        border-radius: 4px;
        box-shadow: var(--av-shadow-small);
        border: 1px solid var(--av-solid-brand-accent);
    }
}
</style>
